export namespace LyftDispatchErrorConstants {
  export const NO_LYFT_DISPATCH_RIDE_FOUND: RegExp = /no active lyftDispatchRide found for rideRequestId=\[[0-9]*\]/;
}
